import { footerColumns } from '@/mocks/homeData';

function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2">
                <span className="flex items-center justify-center w-9 h-9 rounded-md bg-accent-500 text-foreground-950 text-lg">
                  <i className="ri-newspaper-line" />
                </span>
                <span className="font-heading text-xl font-bold">黑料网社</span>
              </div>
              <p className="mt-4 max-w-sm text-sm font-label text-primary-100/80 leading-relaxed">
                把黑料网社的板块、分区、频道与子版主页入口整理成一页导航，栏目清晰，新老用户都能快速找到对味的料。
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                <span className="inline-flex items-center gap-1 h-8 px-3 rounded-full bg-primary-900 text-primary-100 text-xs font-label">
                  <i className="ri-layout-grid-line" />
                  8 大分区
                </span>
                <span className="inline-flex items-center gap-1 h-8 px-3 rounded-full bg-primary-900 text-primary-100 text-xs font-label">
                  <i className="ri-list-check-2" />
                  691 个子版
                </span>
              </div>
            </div>

            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-base font-bold text-background-50">
                  <a href="#top" className="hover:text-accent-300 transition-colors">
                    {column.title}
                  </a>
                </h4>
                <ul className="mt-4 space-y-2.5">
                  {column.items.map((item) => (
                    <li key={item}>
                      <a
                        href="#top"
                        className="text-sm font-label text-primary-100/75 hover:text-background-50 transition-colors"
                      >
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 border-t border-primary-900 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs font-label text-primary-100/70">
              © 2026 黑料网社 · 本站内容均为整理索引，请遵守相关法律法规。
            </p>
            <div className="flex items-center gap-4">
              <a href="#top" className="text-xs font-label text-primary-100/70 hover:text-background-50 transition-colors">
                站点说明
              </a>
              <a href="#tags" className="text-xs font-label text-primary-100/70 hover:text-background-50 transition-colors">
                标签索引
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;